// extracted by mini-css-extract-plugin
export var container = "_5z-0";
export var disabled = "_5z-4";
export var fullWidth = "_5z-3";
export var lined = "_5z-1";
export var selected = "_5z-5";
export var tab = "_5z-2";